<script>
  export default {
    name: 'list-empty',
    props: {
      title: {default: '', Type: String},
      description: {default: 'Nenhum registro encontrado', Type: String},
      type: {default: 'info', Type: String},
      showCloseButton: {default: false, Type: Boolean},
      showIcon: {default: true, Type: Boolean}
    }
  }
</script>

<template>
    <el-alert class="empty-list"
              :title="title"
              :description="description"
              :type="type"
              :closable="showCloseButton"
              :show-icon="showIcon">
    </el-alert>
</template>

<style lang="scss">
    .empty-list {
        .el-alert__content {
            padding: 15px;
            .el-alert__description {
                font-size: 18px;
            }
        }
    }
</style>
